import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { AddFontCollectionButton } from "../../../components/libraries/fontCollections/AddFontCollectionButton";
import { FontCollectionsList } from "../../../components/libraries/fontCollections/FontCollectionsList";
import { useBreadcrumb } from "../../../hooks/navigation/useBreadcrumb";

export const FontCollections: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("libraries");

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("libraries.font_collections.title")}
          breadcrumb={breadcrumb}
          extra={<AddFontCollectionButton />}
        />
      }
    >
      <FontCollectionsList />
    </MainContentArea>
  );
};
